import delParam from './delParam'
import getParam from './getParam'
import serializeParam from './serializeParam'
import cookies from './cookies'
import session_wechat from './session/wechat'

/**
 * 微信跳授权用的
 * @param {String} opt.appid 业务的offerid
 * @param {String} opt.context 授权会带过去
 * @param {String} opt.scope 微信授权的scope
 * @param {Boolean} opt.forceOAuth 每次都强制跳授权。默认是false
 * @param {Boolean} opt.isInBrowser 是否在浏览器中(浏览器中的授权方式不同) 默认是false
 */
export default class wechatOAuth {
  constructor(opt) {
    opt = opt || {};
    /**
     * 公众号的appid
     */
    this.appid = opt.appid || 'wx951bdcac522929b6';

    /**
    * 上下文，授权会带过去
    */
    this.context = opt.context || +new Date();

    /**
     * 微信授权的scope
     */
    this.scope = opt.scope || 'snsapi_base';

    /**
     * refresh_token存储在cookie里的key
     */
    this.refreshTokenKey = this.appid + 'rt';

    var _t;

    if ((_t = opt.code) || (_t = getParam('code'))) {
      //如果url中有code，就标记为CODE

      this._code = _t;

      this.type = TYPE.CODE;

    } else if (~~opt.forceOAuth) {
      //如果强制授权的，就需要授权NEED_OAUTH

      this.type = TYPE.NEED_OAUTH;

    } else if (_t = cookies.get(this.refreshTokenKey)) {
      //如果cookie中有refresht_token就标记为MY_REFRESH_TOKEN
      this._refresh_token = _t;

      this.type = TYPE.MY_REFRESH_TOKEN;

    } else {

      //其他标记为NEED_OAUTH
      this.type = TYPE.NEED_OAUTH;

    }

    // 标记是否在浏览器环境
    this.isInBrowser = opt.isInBrowser || false
  }

  /**
   * init后就能调用getOpenid取用户的openid了
   * @param {Function} opt.onSuccess 能取到code或者refresh_token的成功回调
   * @param {Function} opt.onBeforeOAuth 如果取不到code或者refresh_token就会去跳授权。return false可以阻止跳授权
   * @param {Function} opt.redirectUrl 指定授权回调地址
   */
  init(opt) {
    opt = opt || {};
    //先判断能否取用户的openid信息
    if (this.type === TYPE.NEED_OAUTH) {
      if (opt.onBeforeOAuth && opt.onBeforeOAuth.call(this) === false) {
      } else {
        this.oAuth(opt);
      }
      return false;
    } else {
      opt.onSuccess && opt.onSuccess.call(this);
      return true;
    }
  }
  /**
   * 获取openid
   * @param {Function} opt.onSuccess 成功回调
   * @param {Function} opt.onExpire code或者refresh_token过期了。默认会去跳授权。return false可以阻止跳授权
   * @param {Function} opt.onError 失败回调
   * @param {Function} opt.redirectUrl 指定授权回调地址
   */
  getOpenid(opt) {
    opt = opt || {};

    if (this.type === TYPE.NEED_OAUTH) {
      return false;
    }

    var that = this, response, res;

    //SSI的支持。如果是CODE模式
    if (window._wxinfo !== undefined) {
      response = window._wxinfo;
    } else if (this.type === TYPE.CODE && window._wxinfo1 !== undefined) {
      response = window._wxinfo1;
    } else if (this.type === TYPE.MY_REFRESH_TOKEN && window._wxinfo2 !== undefined) {
      response = window._wxinfo2;
    }

    if (typeof response === 'string') {
      try {
        res = eval('(' + response + ')');
      } catch (e) { }
    } else if (response) {
      res = response;
    }
    //有ssi数据
    if (res) {
      handler(res);
    } else {
      throw new Error('We need get_wechat_userinfo response!');
    }
    function handler(response) {
      var res = response;
      if (res) {
        //请求成功
        if (!~~res.resultcode && res.resultinfo) {
          var userInfo = res.resultinfo;
          that.openid = userInfo.obj.openid;
          that.accessToken = userInfo.obj.access_token;
          that.info = userInfo.obj;

          //缓存的refresh_token要看是否和当前要求scope匹配，如果不匹配、这个时候应该重新让用户授权,不能继续使用此access_token
          if (that.type === TYPE.MY_REFRESH_TOKEN && userInfo.obj.scope.indexOf(that.scope) === -1) {
            that.oAuth(opt);
            return;
          }

          //CODE模式保存refresh_token到cookie
          if (that.type === TYPE.CODE) {
            //将refresh_token存入cookie,10年有效期
            cookies.set(that.refreshTokenKey, userInfo.obj.refresh_token || '', {});
          }

          opt.onSuccess && opt.onSuccess.call(that);

        } else if (~~res.resultcode === 12271) {//过期
          //如果是缓存的refresh_token。需要删掉他，避免下次进来还用到他
          if (that.type === TYPE.MY_REFRESH_TOKEN) {
            that.delRefreshToken();
          }

          if (opt.onExpire && opt.onExpire.call(that) === false) {
          } else {
            that.oAuth(opt);
          }
        } else if (~~res.resultcode === 12273) {//获取用户信息失败

          if (that.type === TYPE.MY_REFRESH_TOKEN) {
            that.delRefreshToken();
            //如果缓存的refresh_token获取用户信息失败了，去跳授权
            that.oAuth(opt);
          } else {
            opt.onError && opt.onError.call(that, res);
          }
          //授权拿到的code不是snsapi_userinfo，给他重新跳授权也没用
        } else {
          that.delRefreshToken();
          opt.onError && opt.onError.call(that, res);
        }
      } else {
        opt.onError && opt.onError.call(that);
      }
    }
  }
  delRefreshToken() {
    cookies.set(this.refreshTokenKey, '', { time: -3600 });
  }
  /**
   * 跳授权
   */
  oAuth(opt) {
    opt = opt || {}
    var redirectUrl = delParam(['code', 'state'], opt.redirectUrl || location.href)

    location.href = 'https://open.weixin.qq.com/' + (this.isInBrowser ? 'sns/explorer_broker' : 'connect/oauth2/authorize') +'?appid=wx951bdcac522929b6&redirect_uri=' + encodeURIComponent(redirectUrl) + '&response_type=code&scope=' + this.scope + '&state=' + this.context + '#wechat_redirect';
  }

  toSession() {
    return new session_wechat({
      openid: this.openid,
      accessToken: this.accessToken,
      appid: this.appid
    });
  }
}

//授权的模式
var TYPE = wechatOAuth.TYPE = {
  //跳授权取code的模式
  CODE: 1,

  //自己种的refresh_token
  MY_REFRESH_TOKEN: 2,

  //需要跳授权
  NEED_OAUTH: 4
};
